import React from "react";

const MyHr: React.FC = () => {
    return (
        <div>
            My HR
        </div>
    )
}

export default MyHr